import { render, staticRenderFns } from "./tiposdecodigosexame.vue?vue&type=template&id=1657cc9f&"
import script from "./tiposdecodigosexame.vue?vue&type=script&lang=js&"
export * from "./tiposdecodigosexame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports